import { Component } from '@angular/core';

@Component({
    selector: 'gl-add-subscriptions-page',
    templateUrl: './add-subscriptions-page.component.html',
    styleUrls: ['./add-subscriptions-page.component.scss']
})
export class AddSubscriptionsPageComponent {}
